module.exports = __webpack_public_path__ + "img/Group795.6da70389.png";